import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBlogs,
  addBlog as addLang,
  updateBlog as updateLang,
  deleteBlog as deleteLang,
  updateBlogStatus as updateLangStatus,
} from "../../services/blogService";
import { toast } from "react-toastify";

const initialState = {
  blogs: [],
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Fetch all blogs
export const fetchBlogs = createAsyncThunk(
  "blogs/fetchBlogs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getBlogs();
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Add a new blog
export const addBlog = createAsyncThunk(
  "blogs/addBlog",
  async (blog, { rejectWithValue }) => {
    try {
      const response = await addLang(blog);
      toast.success(response.message || "Data added successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);



// Update a blog
export const updateBlog = createAsyncThunk(
  "blogs/updateBlog",
  async ({ id, blog }, { rejectWithValue }) => {
    try {
      const response = await updateLang(id, blog);
      toast.success(response.message || "Data updated successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Update a blog status
export const updateBlogStatus = createAsyncThunk(
  "blogs/updateBlogStatus",
  async ({ id, statusObj }, { rejectWithValue }) => {
    try {
      const response = await updateLangStatus(id, statusObj);
      toast.success(response.message || "Status updated successfully!");
      return { id, statusObj };
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Delete a blog
export const deleteBlog = createAsyncThunk(
  "blogs/deleteBlog",
  async (id, { rejectWithValue }) => {
    try {
      let response = await deleteLang(id);
     toast.success(response.message || "Data deleted successfully!");
      return id;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

const blogSlice = createSlice({
  name: "blogs",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Blogs
      .addCase(fetchBlogs.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.blogs = action.payload.data;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

       // Update Blog Status
       .addCase(updateBlogStatus.fulfilled, (state, action) => {
        const {id,statusObj} = action.payload;

        // Ensure `state.languages` exists and is an array
        if (!Array.isArray(state.blogs)) {
            return;
        }
        const index = state.blogs.findIndex((blog) =>{
         return blog._id === id
        });
        if (index !== -1) {
          state.blogs[index] = { ...state.blogs[index], ...statusObj };
        }
      })

        // Add Blog
            .addCase(addBlog.fulfilled, (state, action) => {
              state.blogs.unshift(action.payload.data); // Add at the beginning
            })
      
            // Update Blog
            .addCase(updateBlog.fulfilled, (state, action) => {
              const updatedBlog = action.payload.data;
      
              if (!Array.isArray(state.blogs)) {
                  return;
              }
              const index = state.blogs.findIndex((blog) =>{
               return blog._id === updatedBlog._id
              });
              if (index !== -1) {
                state.blogs[index] = { ...state.blogs[index], ...updatedBlog };
              }
            })


       // Delete Language
       .addCase(deleteBlog.fulfilled, (state, action) => {
        const deletedId = action.payload;
        state.blogs = state.blogs.filter((astro) => astro._id !== deletedId);
      });
     
  },
});

export const { clearError } = blogSlice.actions;
export default blogSlice.reducer;
